<template>
  <div class="issuevars">
    <b-container fluid="xxl">
      <b-row>
        <b-col id="select-issuevar">
          <b-form-group
            id="issuevar"
            label="Issue Var:"
            label-for="issuevar"
          >
            <Select2 @select="select($event)" :settings="selectConfig" ref="select2" tabindex="0" />
          </b-form-group>

          <b-form-group
            id="ordering"
            label="Ordering:"
            label-for="ordering"
            v-if="showOrdering"
          >
            <b-form-input
              id="ordering"
              v-model="ordering"
              placeholder="Ordering"
            ></b-form-input>
          </b-form-group>
        </b-col>
      </b-row>
    </b-container>

    <b-modal id="modal-new-issue-var" title="New Issue Var" ok-title="Save" @ok="saveNew" >
      <IssueVarNewEdit :issuevar="{'form': this.query}" />
    </b-modal>
  </div>
</template>

<script>
import HelpStore from "@/store/helpstore.js";
import Select2 from 'v-select2-component';
import IssueVarNewEdit from "@/components/Scripta/IssueVarNewEdit.vue";
import config from '@/config.js';

export default {
  name: "IssueVarAutocomplete",
  props: ["exclude", "issueVar", "showOrdering", "headId", "orderingNum", "parentId"],
  data() {
    return {
      query: "",
      timer: null,
      issueVarObj: this.issueVar,
      parentIdElem: this.parentId ? this.parentId : "select-issuevar",
      ordering: this.issueVar ? this.issueVar.ordering : (this.orderingNum ? this.orderingNum : 1),
      index: this.issueVar ? this.issueVar._index : null,
      showAddNew: this.allowNew == false ? false : true,
    };
  },
  components: {
    Select2,
    IssueVarNewEdit,
  },
  methods: {
    select(event){
      if (event.selected && event.id == -2){
        this.$bvModal.show("modal-new-issue-var")
      }
      else {
        this.issueVarObj = event.selected ? event.issueVar : null
        this.$emit("select", this.issueVarObj)
        this.update()
      }
    },
    saveNew(){
      this.$store.dispatch('createIssuevar', HelpStore.item).then((response) => {
        this.issueVarObj = response.data
        this.$refs.select2.select2.append(
          `<option selected value="${this.issueVarObj.id}">${this.issueVarObj.form}</option>`
        ).trigger('change')
        HelpStore.item = this.issueVarObj
      })
    },
    update(){
      if (this.issueVarObj){
        this.issueVarObj["ordering"] = this.ordering;
        this.issueVarObj["_index"] = this.index;
        HelpStore.item = this.issueVarObj;
      }
    },
  },
  updated() {
    this.update()
  },
  mounted() {
    if (this.issueVar){
      this.$refs.select2.select2.append(
        `<option selected value="${this.issueVar.id}">${this.issueVar.form}</option>`
      ).trigger('change')
    }
  },
  computed: {
    selectConfig(){
      return {
        placeholder: "Select an issue var",
        // allowClear: this.allowClear == false ? false : true,
        width: '100%',
        dropdownParent: `#${this.parentIdElem}`,
        templateSelection: (val) => {
          return val.form ? val.form : val.text
        },
        ajax: {
          delay: 250,
          url: config.apiUrl + '/issuevars/autocomplete',
          headers: config.apiHeaders,
          data: (params) => {
            this.query = params.term
            return {
              query: params.term,
              // headId: this.headId,
              exclude: JSON.stringify(this.exclude),
            }
          },
          processResults: (data) => {
            if (data.length == 0 && this.showAddNew && this.query){
              data.push({
                id: -2,
                form: `Create new "${this.query}"`
              })
            }
            return {
              results: data.map(issueVar => {
                let text = issueVar.form
                let orderNum = 0
                if (issueVar.id != -2 && !issueVar.heads.map(head => head.id).includes(this.headId)) {
                  text = `${text} (not connected to head)`
                  orderNum = 1
                }
                return {
                  id: issueVar.id,
                  text: text,
                  orderNum: orderNum,
                  form: issueVar.form,
                  issueVar: issueVar
                }
              }).sort((a, b) => a.orderNum - b.orderNum)
            }
          }
        }
      }
    }
  },
};
</script>
